import * as React from 'react';
import MuiCheckbox from '@material-ui/core/Checkbox';

const fieldToCheckbox = ({
  field,
  form: { isSubmitting },
  disabled = false,
  ...props
}) => {
  return {
    disabled: isSubmitting || disabled,
    ...props,
    ...field,
    // TODO handle indeterminate
    checked: field.value,
    value: field.value ? 'checked' : ''
  };
};

export default function Checkbox({ children, ...props }) {
  return <MuiCheckbox {...fieldToCheckbox(props)} />;
}

Checkbox.displayName = 'FormikMaterialUICheckbox';
